import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import jane from "../assets/img/jane.png";

export const About = () => {
  return (
    <div className="about-container">
      <div className="block-container bio-container bottom-space up-space">
        <Row>
          <Col xs={12}>
            <div className="central-block-bio">
              <h2 style={{ fontFamily: "Raleway" }}>
                Jane Kuehn-Tucker Bayonne : Qui suis-je ?
              </h2>
              <img src={jane} className="jane-img" />
              <h5>
                <strong style={{ fontFamily: "Raleway" }}>
                  Channel-Thérapeute, Berceuse, Passeuse d’Âme et Coach de Vie
                </strong>
              </h5>
              <br />
              <p>
                Avec mes parents irlandais et allemand, j’arrive à PARIS à cinq
                ans. Naturellement <strong>trilingue</strong> et pluri-
                culturelle, pour moi le monde n’a pas de frontières.
              </p>
              <br />
              <p>
                À 4 ans, je prononce mes premières paroles inspirées à
                l'attention de ma grand-mère. Elle s’en souviendra toujours.
              </p>
              <br />
              <p>
                A 14 ans, m’interrogeant sur le sens de la Vie, j’écris et je
                chante mes premières chansons. Ce sont des{" "}
                <strong>messages d’espoir</strong> qui jaillissent spontanément.
              </p>
              <br />
              <p>
                Parallèlement à mon premier métier de Chef de Produit
                Cosmétique, je suis les cours d’Alice DONA, j’approfondis
                l’écriture avec Claude LEMESLE et je travaille le chant avec
                Raymonde VIRET. L’artistique apaise ma sensibilité et affine mon
                intuition.
              </p>
              <br />
              <p>
                Mes <strong>paroles inspirées</strong> et ma{" "}
                <strong>vision différente</strong> des choses{" "}
                <strong>encouragent</strong> de nombreuses personnes.
              </p>
              <br />
              <p>
                Puis, une psychothérapie me fait comprendre que toute souffrance
                comporte une part inconsciente, karmique et subtile.{" "}
              </p>
              <br />
              <p>
                1988 marque ma rencontre avec <strong>Rido BAYONNE</strong>,
                musicien, compositeur, arrangeur, chef d’orchestre. Sa
                bienveillance, sagesse et liberté créative me touchent. Lui
                trouve ma plume accordée à son inspiration. Ensemble, nous
                réalisons 5 albums, dont ‘ALLIANCES’ et ‘LUMIERE’.
              </p>
              <br />
              <p>
                Rido BAYONNE m’introduit au{" "}
                <strong>Bouddhisme de Nichiren DAISHONIN</strong>, une
                philosophie qui répond aux questions que je me pose sur la Vie.
                Je découvre un Maître, <strong>Daisaku IKEDA</strong>, et
                d’importants principes, dont ’les 10 Etats’, la 'Révolution
                Humaine, et '3000 Mondes en un Instant de Vie'’.
              </p>
              <br />
              <p>
                Grâce à la récitation du mantra et l’étude bouddhique, je
                repousse mes limites et découvre la joie profonde.
              </p>
              <br />
              <p>
                Puis, un voyage en Inde affine mes dons spirituels et me guide
                vers le <strong>Channeling Thérapeutique</strong>. Lorsque je
                donne une séance, je reçois les mots et énergies{" "}
                <strong>libérateurs</strong> dont l’autre a besoin pour{" "}
                <strong>dépasser ses blessures d’âme</strong>.
              </p>
              <br />
              <p>
                Lors d’un <strong>Channeling Thérapeutique</strong>, je peux
                être amenée à aider en tant que <strong>Passeuse d’âme</strong>.
                En fin de vie, j’apaise et j’accompagne. Après le décès,
                j’oriente l’âme vers la Lumière si pour une raison ou une autre
                elle tarde à se détacher de sa vie terrestre.
              </p>
              <br />
              <p>
                Le <strong>Channeling</strong> est particulièrement adapté à
                l’occasion d’une <strong>naissance</strong>. J’entre{" "}
                <strong>en communication télépathique</strong> avec le{" "}
                <strong>bébé à naître ou déjà né</strong> pour connaître ses
                besoins psychologiques et émotionnels et lui permettre de
                dialoguer avec ses parents.{" "}
              </p>
              <br />
              <p>
                Un <strong>Dialogue d’Âme</strong> est possible à tout âge, tout
                au long de la vie. Il agit comme un{" "}
                <strong>miroir intérieur</strong> qui éclaire nos{" "}
                <strong>potentiels</strong> enfouis et nous révèle à nous-même.
              </p>
              <br />
              <p>
                <strong>Transmettre toujours…</strong> au fur et à mesure, je
                suis portée vers le <strong>Coaching</strong>, dont celle des
                langues. Ma compréhension intuitive des difficultés et mes
                explications inspirées permettent de dénouer des blocages datant
                souvent de la scolarité. Quelle joie lorsque jaillit un talent
                linguistique insoupçonné !
              </p>
              <br />
              <p>
                Enfin, j’ai été <strong>Berceuse</strong> à{" "}
                <strong>l’Hôpital Robert Debré de Paris</strong> où j’ai été
                interpellée par les multiples inquiétudes des bébés dont l’âme
                s’interroge parfois sur sa légitimité et sa capacité à réaliser
                ses buts d’incarnation.
              </p>
              <br />
              <p>
                C’est pour ces enfants et leurs parents que j’ai{" "}
                <strong>écrit « Rim-la-Belle et son Monde Merveilleux »</strong>
                , une Collection de Livres-Cds visant à les aider à grandir.
                Mots et musiques les initient en douceur à la conscience de la
                Nature, aux liens subtils qui nous relient, à la connexion à
                notre Terre, à nos <strong>ressources</strong> intérieures et à
                une forme simple d’<strong>éveil</strong>.
              </p>
              <br />
              <p>
                Le sens de <em>ma vie&nbsp;</em>?&nbsp;
              </p>{" "}
              <br />
              <p align="center">
                <strong>
                  Contribuer à la beauté du Monde
                  <br />
                  Guérir les âmes et les cœurs ...
                </strong>
              </p>
              <br />
              <div className="bouton-rectangle-container">
                <Link to={"/contact"} className="bouton-rectangle-music">
                  Me contacter
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
